export default __webpack_public_path__ + "static/N0249-b29ae9230dfd2de6ecc04b1d262d7fcd.png";